import { sendRequest } from 'best-modules/vue-utils'
import type {
  AttributeSearchForm,
  FullTextSearchForm,
  RawSearchResult,
  SearchPaginationResponse,
} from '@/utils/types/search'
import type { Query } from 'best-modules/utils'

const edsSearchAttribute = (
  form: AttributeSearchForm,
  query: Query
): Promise<SearchPaginationResponse<RawSearchResult>> => {
  return sendRequest({
    name: 'edsSearchAttribute',
    method: 'post',
    url: {
      url: '/json/eds-search/attribute',
      query,
    },
    payload: form,
  })
}

const edsSearchFullText = (
  form: FullTextSearchForm,
  query: Query
): Promise<SearchPaginationResponse<RawSearchResult>> => {
  return sendRequest({
    name: 'edsSearchFullText',
    method: 'post',
    url: {
      url: '/json/eds-search/full-text',
      query,
    },
    payload: form,
  })
}

export { edsSearchAttribute, edsSearchFullText }
